import { Outlet, useNavigate, useRouterState } from '@tanstack/react-router';
import { AppShell, BrandMark } from '@opengoal/ui';
import { useTranslation } from 'react-i18next';
import { useNavGroups } from '@/app/navigation';
import { env } from '@/app/env';
import { HeaderControls } from '@/app/header/HeaderControls';

/**
 * Chrome for every authenticated screen: sidebar, header, content area.
 *
 * The auth guard lives on the route (see app/routes/roots.tsx), not here — a
 * component-level guard renders once before it redirects, which briefly flashes
 * the app shell to a signed-out user.
 */
export function AppLayout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const navGroups = useNavGroups();
  const pathname = useRouterState({ select: (state) => state.location.pathname });

  return (
    <AppShell
      brand={<BrandMark name={env.appName} tagline={t('app.tagline')} />}
      brandCollapsed={<BrandMark name={env.appName} markOnly size="sm" />}
      navGroups={navGroups}
      selectedKey={pathname}
      onNavigate={(key) => void navigate({ to: key })}
      headerRight={<HeaderControls />}
    >
      <Outlet />
    </AppShell>
  );
}
